import _o2sService from './_o2sServices';
import { IFilter } from '../models/filters/filter';
import { IProductionAnalyseFilter } from '../models/filters/productionAnalyseFilter';
import { IProductionAnalyseForm } from '../models/forms/productionAnalyseForm';
import { IProductionAnalysePDTO } from '../models/dtos/productionAnalysePDTO';
import { API_CENTRE } from './config';

export default class ProductionAnalyseServices extends _o2sService {
   protected static override mainUrl:string = API_CENTRE + '/api/v1/ProductionAnalyses';
   protected static override getUrlFilter<F extends IProductionAnalyseFilter>(filter?: F): string {;
       let url = super.getUrlFilter(filter as IFilter);
       if (filter != null)
       {
            if (filter.animalId != null)
                url += `&AnimalId=${filter.animalId}`;
           if (filter.productionId != null)
               url += `&ProductionId=${filter.productionId}`;
           if (filter.typeAnomalyId != null)
               url += `&TypeAnomalyId=${filter.typeAnomalyId}`;
           if (filter.centerId != null)
               url += `&CenterId=${filter.centerId}`;
           if (filter.dateFrom != null)
               url += `&DateFrom=${filter.dateFrom.toISOString()}`;
       }
       return url;
   }

   public static override toDTO(dic: IProductionAnalyseForm): IProductionAnalysePDTO {
       const dto = super.toDTO(dic) as IProductionAnalysePDTO;
       return dto;
   }

}
